let poderAncestral = window.location.ancestorOrigins[0];

let autorizar: boolean = false;

if (window.location.host.toLocaleLowerCase().includes("localhost")) {
  autorizar = true;
} else if (poderAncestral !== undefined) {
  if (window.location.ancestorOrigins[0].toLocaleLowerCase().includes("starken.topdesk.net")) {
    autorizar = true;
  }
}

// else if (window.location.host.toLocaleLowerCase().includes("mytopdeskqa.starken.cl")){
//   autorizar = true;
// }

//git sta

var referrer = document.referrer;
console.log("referrer url", referrer);

const NOCHERO: string = "" + process.env.REACT_APP_API_NOCHERO;

let NOCHERO_USER: string = "" + process.env.REACT_APP_API_NOCHERO_USER;
let NOCHERO_PASS: string = "" + process.env.REACT_APP_API_NOCHERO_PASS;

export const AUTENTICACION_NOCHERO = {
  user: NOCHERO_USER,
  pass: NOCHERO_PASS
}


let CONSULTA_TOPDESK: string = "" + process.env.REACT_APP_CONSULTA_TOPDESK;

let CONSULTA_TDK_TRACKING: string = "" + process.env.REACT_APP_CONSULTA_TDK_TRACKING;
let CONSULTA_TDK_TRACKING_PRD: string = "" + process.env.REACT_APP_CONSULTA_TDK_TRACKING_PRD;
let CONSULTA_TDK_TRACKING_QA: string = "" + process.env.REACT_APP_CONSULTA_TDK_TRACKING_QA;

let TDK_USER_PRD: string = "" + process.env.REACT_APP_TDK_USER_PRD;
let TDK_PASS_PRD: string = "" + process.env.REACT_APP_TDK_PASS_PRD;

export const AUTENTICATION_TDK_PRD = {
  user: TDK_USER_PRD,
  pass: TDK_PASS_PRD
}

let TDK_USER_QA: string = "" + process.env.REACT_APP_TDK_USER_QA;
let TDK_PASS_QA: string = "" + process.env.REACT_APP_TDK_PASS_QA;

export const AUTENTICATION_TDK_QA = {
  user: TDK_USER_QA,
  pass: TDK_PASS_QA
}

let PLANIFICADOR_RUTA_PRD: string = "" + process.env.REACT_APP_PLANIFICADOR_RUTA_PRD;
let PLANIFICADOR_RUTA_QA: string = "" + process.env.REACT_APP_PLANIFICADOR_RUTA_QA;

let PLANIFICADOR_RUTA_USER: string = "" + process.env.REACT_APP_PLANIFICADOR_RUTA_USER;
let PLANIFICADOR_RUTA_PASS: string = "" + process.env.REACT_APP_PLANIFICADOR_RUTA_PASS;

export const AUTENTICATION_PLANIFICADOR_RUTA = {
  user: PLANIFICADOR_RUTA_USER,
  pass: PLANIFICADOR_RUTA_PASS
}



let ENCARGO_RUTEO_PRD: string = "" + process.env.REACT_APP_ENCARGO_RUTEO_PRD;
let ENCARGO_RUTEO_QA: string = "" + process.env.REACT_APP_ENCARGO_RUTEO_QA;

let ENCARGO_RUTEO_USER: string = "" + process.env.REACT_APP_ENCARGO_RUTEO_USER;
let ENCARGO_RUTEO_PASS: string = "" + process.env.REACT_APP_ENCARGO_RUTEO_PASS;


export const AUTENTICATION_ENCARGO_RUTEO = {
  user: ENCARGO_RUTEO_USER,
  pass: ENCARGO_RUTEO_PASS
}


let RUTEO_WEB: string = "" + process.env.REACT_APP_RUTEO_WEB;




// PLANITRACK API
const PLANITRAK: string = "" + process.env.REACT_APP_PLANITRAK;

// AGENCIAS
const DATOS: string = "" + process.env.REACT_APP_DATOS;

// COTIZADOR
const COTIZADOR: string = "" + process.env.REACT_APP_COTIZADOR;



// ESTADOS
const EXTRAVIADO: number = Number(process.env.REACT_APP_EXTRAVIADO);
const PENDIENTE_DESPACHO: number = Number(process.env.REACT_APP_PENDIENTE_DESPACHO);
const NOMINADO: number = Number(process.env.REACT_APP_NOMINADO);
const EN_TRANSITO: number = Number(process.env.REACT_APP_EN_TRANSITO);
const PENDIENTE_ENTREGA: number = Number(process.env.REACT_APP_PENDIENTE_ENTREGA);
const EN_REPARTO: number = Number(process.env.REACT_APP_EN_REPARTO);
const PENDIENTE_ENTREGA_EX: number = Number(process.env.REACT_APP_PENDIENTE_ENTREGA_EX);

const ANULADO: number = Number(process.env.REACT_APP_ANULADO);
const CERRADO_EXCEPCION: number = Number(process.env.REACT_APP_CERRADO_EXCEPCION);
const DECOMISADO: number = Number(process.env.REACT_APP_DECOMISADO);
const DEVUELTO: number = Number(process.env.REACT_APP_DEVUELTO);
const ENTREGADO: number = Number(process.env.REACT_APP_ENTREGADO);
const REDESTINADO: number = Number(process.env.REACT_APP_REDESTINADO);
const REMATADO: number = Number(process.env.REACT_APP_REMATADO);

export const inicio = {
  permitido: autorizar,
}


export const ESTADOS = {
  EXTRAVIADO: EXTRAVIADO,
  PENDIENTE_DESPACHO: PENDIENTE_DESPACHO,
  NOMINADO: NOMINADO,
  EN_TRANSITO: EN_TRANSITO,
  PENDIENTE_ENTREGA: PENDIENTE_ENTREGA,
  EN_REPARTO: EN_REPARTO,
  PENDIENTE_ENTREGA_EX: PENDIENTE_ENTREGA_EX,
  ANULADO: ANULADO,
  CERRADO_EXCEPCION: CERRADO_EXCEPCION,
  DECOMISADO: DECOMISADO,
  DEVUELTO: DEVUELTO,
  ENTREGADO: ENTREGADO,
  REDESTINADO: REDESTINADO,
  REMATADO: REMATADO
}

const CENTRO_DISTRIBUCION: number = Number(process.env.REACT_APP_CENTRO_DISTRIBUCION);

export const C_D = {
  CENTRO_DISTRIBUCION: CENTRO_DISTRIBUCION
}



let TRACKING_DETALLE: string = "" + process.env.REACT_APP_TRACKING;

let TRACKING_RESUMEN: string = "" + process.env.REACT_APP_TRACKING;

let TRACKING_SEGUIMIENTO_ENCARGO: string = "" + process.env.REACT_APP_TRACKING;

let REDESTINACION_CONSULTA_DESTINATARIO_BY_OF: string = "" + process.env.REACT_APP_REDESTINACION;

let REDESTINACION_COTIZACION_REDESTINACION: string = "" + process.env.REACT_APP_REDESTINACION;

let REDESTINACION_AGENCIA: string = "" + process.env.REACT_APP_REDESTINACION;

let REDESTINACION_DEVOLUCION_AGENCIA: string = "" + process.env.REACT_APP_REDESTINACION;

let COTIZACION_CONSULTA: string = "" + process.env.REACT_APP_COTIZACION;

let CTA_CTE_POR_NUMERO: string = "" + process.env.REACT_APP_CTA_CTE;

let CTA_CTE_POR_RUT: string = "" + process.env.REACT_APP_CTA_CTE;

let NOMINA: string = "" + process.env.REACT_APP_NOMINA;

let ORDEN_FLETE: string = "" + process.env.REACT_APP_ORDEN_FLETE;

let RECLAMO: string = "" + process.env.REACT_APP_RECLAMO;







let CONSULTA_TDK_OBS: string = "" + process.env.REACT_APP_CONSULTA_TDK_OBS;

let CONSULTA_TDK_POD: string = "" + process.env.REACT_APP_CONSULTA_TDK_POD;

let CONSULTA_TDK_EXCEP: string = "" + process.env.REACT_APP_CONSULTA_TDK_EXCEP;

let CONSULTA_TDK_RECLA: string = "" + process.env.REACT_APP_CONSULTA_TDK_RECLA;

let CONSULTA_TDK_OFMASIVA: string = "" + process.env.REACT_APP_CONSULTA_TDK_OFMASIVA;

let CONSULTA_TDK_OF_REDESTINADA: string = "" + process.env.REACT_APP_CONSULTA_OF_REDESTINADA;

let CONSULTA_TDK_DETALLE_PAGOS: string = "" + process.env.REACT_APP_CONSULTA_TDK_DETALLE_PAGOS;

let CONSULTA_BEETRACK: string = "" + process.env.REACT_APP_CONSULTA_BEETRACK;

let CONSULTA_TICKET_TOPDESK: string = "" + process.env.REACT_APP_CONSULTA_TICKET_TOPDESK;

let AGENCIA_TDK: string = "" + process.env.REACT_APP_AGENCIA_TDK;









export const MICROSERVICIOS = {

  // TRACKING
  TRACKING_DETALLE:                   //detalle
    TRACKING_DETALLE,

  TRACKING_RESUMEN:                   //resumen
    TRACKING_RESUMEN,

  TRACKING_SEGUIMIENTO_ENCARGO:       //seguimientoEncargo
    TRACKING_SEGUIMIENTO_ENCARGO,

  // REDESTINACION OK
  REDESTINACION_CONSULTA_DESTINATARIO_BY_OF:      // consultaDestinatarioByOf
    REDESTINACION_CONSULTA_DESTINATARIO_BY_OF,

  REDESTINACION_COTIZACION_REDESTINACION:         // cotizacionRedestinacion
    REDESTINACION_COTIZACION_REDESTINACION,

  REDESTINACION_AGENCIA:                          // redestinacionAgencia 
    REDESTINACION_AGENCIA,

  REDESTINACION_DEVOLUCION_AGENCIA:               // redestinacionDevolucionAgenciaS
    REDESTINACION_DEVOLUCION_AGENCIA,

  // COTIZACION OK
  COTIZACION_CONSULTA:
    COTIZACION_CONSULTA,

  // CTA_CTE
  CTA_CTE_POR_NUMERO:
    CTA_CTE_POR_NUMERO, // CtaCteReturnByNumCtaCte

  CTA_CTE_POR_RUT:
    CTA_CTE_POR_RUT,  // CtaCteReturnListByRut

  // NOMINA
  NOMINA:
    NOMINA, // getOrdenesFletes

  // ORDEN FLETE
  ORDEN_FLETE:
    ORDEN_FLETE, // insertaObservacion Y update

  // RECLAMO
  RECLAMO:
    RECLAMO, // actualizaOfByFolio     ,   ingresaObsReclamo ,  ingresoReclamoStep1 , ingresoReclamoStep2 , reclamoDetalleSeguimiento

  DATOS:
    DATOS,

  PLANITRAK:
    PLANITRAK,

  CONSULTA_TOPDESK:
    CONSULTA_TOPDESK,

  CONSULTA_TDK_TRACKING:
    CONSULTA_TDK_TRACKING,

  CONSULTA_TDK_TRACKING_PRD:
    CONSULTA_TDK_TRACKING_PRD,

  CONSULTA_TDK_TRACKING_QA:
    CONSULTA_TDK_TRACKING_QA,

  ENCARGO_RUTEO_PRD: ENCARGO_RUTEO_PRD,
  ENCARGO_RUTEO_QA: ENCARGO_RUTEO_QA,

  PLANIFICADOR_RUTA_PRD: PLANIFICADOR_RUTA_PRD,
  PLANIFICADOR_RUTA_QA: PLANIFICADOR_RUTA_QA,

  CONSULTA_TDK_OBS:
    CONSULTA_TDK_OBS,

  COTIZADOR:
    COTIZADOR,

  CONSULTA_TDK_POD:
    CONSULTA_TDK_POD,

  CONSULTA_TDK_EXCEP:
    CONSULTA_TDK_EXCEP,

  CONSULTA_TDK_RECLA:
    CONSULTA_TDK_RECLA,

  CONSULTA_TDK_OFMASIVA:
    CONSULTA_TDK_OFMASIVA,

  CONSULTA_TDK_OF_REDESTINADA:
    CONSULTA_TDK_OF_REDESTINADA,

  CONSULTA_TDK_DETALLE_PAGOS:
    CONSULTA_TDK_DETALLE_PAGOS,

  CONSULTA_BEETRACK:
    CONSULTA_BEETRACK,

  CONSULTA_TICKET_TOPDESK:
    CONSULTA_TICKET_TOPDESK,

  AGENCIA_TDK:
    AGENCIA_TDK,

  NOCHERO:
    NOCHERO,

  RUTEO_WEB:
    RUTEO_WEB,

}





let CRM_USER: string = "" + process.env.REACT_APP_CRM_USER;
let CRM_PASS: string = "" + process.env.REACT_APP_CRM_PASS;

export const AUTENTICACION = {
  user: CRM_USER,
  pass: CRM_PASS
}

let TDK_USER: string = "" + process.env.REACT_APP_TDK_USER;
let TDK_PASS: string = "" + process.env.REACT_APP_TDK_PASS;

export const AUTENTICATION_TDK = {
  user: TDK_USER,
  pass: TDK_PASS
}




let USER_TICKET: string = "" + process.env.REACT_APP_USER_TICKET;
let PASS_TICKET: string = "" + process.env.REACT_APP_PASS_TICKET;

export const AUTENTICATION_TICKET_TOPDESK = {
  user: USER_TICKET,
  pass: PASS_TICKET
}


let USER_CM: string = "" + process.env.REACT_APP_CM_USER;
let PASS_CM: string = "" + process.env.REACT_APP_CM_USER;

export const AUTENTICACION_CM = {
  user: USER_CM,
  pass: PASS_CM
}


let TOKEN_AGENCY: string = "" + process.env.REACT_APP_DATOS_TOKEN_AGENCY;

export const DATOS_TOKEN = {
  token: TOKEN_AGENCY
}

let TOKEN_PLANITRAK_1: string = "" + process.env.REACT_APP_PLANITRAK_TKN;
let TOKEN_PLANITRAK_2: string = "" + process.env.REACT_APP_PLANITRAK_TKN2;
let TOKEN_PLANITRAK_3: string = "" + process.env.REACT_APP_PLANITRAK_TKN3;

export const PLANITRAK_TKN = {
  token: TOKEN_PLANITRAK_1,
  token2: TOKEN_PLANITRAK_2,
  token3: TOKEN_PLANITRAK_3
}

let TOKEN_BEETRACK: string = "" + process.env.REACT_APP_BEETRACK_TKN;

export const BEETRACK_TKN = {
  token: TOKEN_BEETRACK
}

let TIME_OUT: number = Number(process.env.REACT_APP_REQUEST_TIMEOUT);

export const REQUEST_TIMEOUT = TIME_OUT; // segundos

let CANT_OBS: number = Number(process.env.REACT_APP_NUMERO_OBS);

export const NUMERO_OBS = CANT_OBS;


let CANT_TOTAL: number = Number(process.env.REACT_APP_CANT_TOTAL);

export const CANTIDAD_TOTAL = CANT_TOTAL;

let DS_POR_VENCER: number = Number(process.env.REACT_APP_DIAS_POR_VENCER);

let DS_VENCIDOS: number = Number(process.env.REACT_APP_DIAS_VENCIDOS);

let DS_DENTRO_PLAZO: number = Number(process.env.REACT_APP_DIAS_DENTRO_PLAZO);

export const DIAS_DENTRO_PLAZO = DS_DENTRO_PLAZO;
export const DIAS_POR_VENCER = DS_POR_VENCER;
export const DIAS_VENCIDOS = DS_VENCIDOS;

